import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import { TermDatasource } from '../infra/datasources/TermDatasource'

export const placeFetchAdapter: TermDatasource = {
  async getUserTermList(userId, language) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/terms/${userId}/terms?language=${language}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    return await response.json()
  },
  async userAcceptTerm(userId, device) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/terms/${userId}`,
          httpTokenInterceptor({
            method: 'PUT',
            body: JSON.stringify({ device: device }),
            headers: {
              'content-type': 'application/json'
            }
          })
        )
      )
    )
  }
}
